module.exports = __webpack_public_path__ + "1791188489487/fonts/WorkSans-Medium.e0522d9.woff";